// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section-module--Section--CsL9G"};